import { Injectable } from '@angular/core';
import { WebApiService } from '../../../../shared/services/web-api.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';

@Injectable({
  providedIn: 'root'
})
export class RfqGenerateFormService {

  constructor(
    private webApiService: WebApiService,
    private rfqTokenAuth: RfqTokenAuthService
    ) { }

  getAllSubcategories(categoryId: any): Promise<any> {
    let apiUrl = `/impa/fetchSubCategoryDetails/${categoryId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getRfqItem(rfqId:number): Promise<any> {
    let apiUrl = `/rfq/cart/getSelectedCartItemsForRfq/${rfqId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getImpaCatalogue(categoryId: any): Promise<any> {
    let apiUrl = `/impa/fetchDetails`;
    return this.webApiService.postRequest<any>(apiUrl, {
      categoryIds: categoryId
    });
  }

  saveRfq(rfqId: number, headerData: any, lineItemData: any, paymentTermsData: any,lineItemTableData:any): Promise<any> {
    let apiUrl = `/rfq/save/`;
    return this.webApiService.postRequest<any>(apiUrl, {
      metaData: {
        rfqId
      },
      headerData,
      lineItemData,
      paymentTermsData,
      lineItemTableData
    });
  }

  getLeafNodeFromCategoryId(subcategoryId: any): Promise<any> {
    let apiUrl = `/impa/fetchLeafNodeFromCategoryId/${subcategoryId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getAllpaymentTerms():Promise<any>{ 
    let apiUrl = `/rfq/getAllpaymentTerms`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  getAllpaymentTermsByRfqToken():Promise<any>{ 
    let apiUrl = `/rfq/getAllpaymentTermsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  fetchSupplierRfqListRequiredData(params:any):Promise<any>{ 
    let apiUrl = `/rfq/fetchSupplierRfqListRequiredData`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  getAllSuppliersForCartItem(impaId:number):Promise<any>{
    let apiUrl = `/rfq/fetchsupplierDetails/${impaId}`;
    return this.webApiService.getRequest<any>(apiUrl)

  }

  getSuggestedSupplierByImpaId(params: any): Promise<any> {
    let apiUrl = `/rfq/getSuggestedSupplierByImpaId`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getMySupplierByBuyerId(params: any): Promise<any> {
    let apiUrl = `/rfq/getMySupplierByBuyerId`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getRFQDraftData(tab:string,buyerId:number):Promise<any>{
    let apiUrl = `/rfq/getRfqDraftData/${tab}/${buyerId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }
  

  saveRfqAsDraft(params: any): Promise<any> {
    let apiUrl = `/rfq/saveAsdraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  createRfq(params: any): Promise<any> {
    let apiUrl = `/rfq/createRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  updateRfqAsDraft(params: any): Promise<any> {
    let apiUrl = `/rfq/updateRfqDraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  
  getSupplierDetails(rfqId:number, productId:number):Promise<any>{
    let apiUrl = `/rfq/getSupplierDetails/${rfqId}/${productId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  
  getSupplierPaymentDetails(rfdDetailsId:number):Promise<any>{
    let apiUrl = `/rfq/getSupplierPaymentDetails/${rfdDetailsId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  
  async sendRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/rfq/sendRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  async reSendRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/rfq/reSendRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  verifyRfqToken(token: string): Promise<any> {
    let apiUrl = `/rfq/verify-rfq-token`;
    return this.webApiService.postRequest<any>(apiUrl, { token: (token || '').trim() });
  }

  async sendRfq(params:any):Promise<any>{
    let apiUrl = `/rfq/sendRfq`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  async uploadRfqAttachment(params:any):Promise<any>{
    let apiUrl = `/rfq/uploadRfqAttachment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  
  getlastRfqId():Promise<any>{
    let apiUrl = `/rfq/getlastRfqId`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  
  

}
